/*
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:44:43
 * @LastEditTime: 2022-07-15 15:42:28
 */
import $axios from './axios.js'
import {patientApi} from "./webpatient"
import {micApi} from "./mic"
const baseUrl = '/v1/webpatient'; // 小程序
const baseUrl1= "/v1/sms-api";  // 短信
const baseUrl2= "https://ssc.boe.com/v1/medical-api";
const API = {
   // 获取公匙接口
   getPublicKey(data = {}) {
    return $axios.get(baseUrl+"/rsa/public", {
      params: { ...data }
    });
  },
   // 成都医院-发送验证码
   cdSendYzm(data = {}) {
    return $axios.post(baseUrl1+"/sms/sendCode", data);
  },
  // 成都医院密码登录
  cdLogin(data = {}) {
    return $axios.post(baseUrl+"/user/login", data);
  },
   // 成都医院验证码登录
   cdLoginSmsCode(data = {}) {
    return $axios.post(baseUrl+"/user/loginBySmsCode", data);
  },
  // 成都医院忘记密码
  cdResetPassword(data = {}) {
    return $axios.post(baseUrl+"/user/resetPc", data);
  },
  // 成都医院修改密码
  cdUpdatePassword(data = {}) {
    return $axios.post(baseUrl+"/user/modifyPc", data);
  },
  
  // 苏州医院-发送短信验证码
  szSendYzm(data = {}) {
    return $axios.post(baseUrl+"/sms/sendCode", data);
  },
  // 个人中心-苏州医院-获取就诊人列表
  getPatientList(data = {}) {
    return $axios.get(baseUrl+"/patient/list", {
      params: { ...data }
    });
  },
  // 苏州医院添加就诊人
  addPatientSZ(data = {}) {
    return $axios.post(baseUrl+"/patient/add/suzhou", data);
  },
  // 苏州医院门诊电子发票
  getOutpatientInvoiceList(data = {}) {
    return $axios.post(baseUrl+"/invoice/pay/list", data);
  },
  // 获取个人门诊预约记录列表
  getOutpatientBookList(data = {}) {
    return $axios.get(baseUrl+"/book/list", {
      params: { ...data }
    });
  },
  // 获取个人体检预约记录列表
  getExamBookList(data = {}) {
    return $axios.get(baseUrl+"/medical/exam/book/list", {
      params: { ...data }
    });
  },
  // 取消门诊预约
  cancelOutpatientBook(data = {}) {
    return $axios.get(baseUrl+"/book/cancel", {
      params: { ...data }
    });
  },
  // 门诊预约退号
  outpatientRefund(data = {}) {
    return $axios.post(baseUrl+"/book/refund", data);
  },
  // 体检预约退号
  examRefund(data = {}) {
    return $axios.post(baseUrl+"/medical/exam/book/refund", data);
  },
  // 取消体检预约
  cancelExamBook(data = {}) {
    return $axios.post(baseUrl+"/medical/exam/book/cancel", data);
  },
  // 成都医院去支付--电脑端
  goPay(data = {}) {
    return $axios.post(baseUrl+"/pay/qrcode", data);
    // return $axios.post(baseUrl+"/pay/unify", data);
  },
  // 成都医院去支付--手机端
  goPayPhone(data = {}) {
    return $axios.post(baseUrl+"/pay/web", data);
  },
  // 医院去支付
  goPaySuzhou(data = {}) {
    return $axios.post(baseUrl+"/pay/unify", data);
  },
  // 检查门诊预约支付状态
  checkPaymentStatus(data = {}) {
    return $axios.get(baseUrl+"/book/status", {
      params: { ...data }
    });
  },
  // 检查体检预约支付状态
  checkExamPaymentStatus(data = {}) {
    return $axios.get(baseUrl+"/medical/exam/book/status", {
      params: { ...data }
    });
  },
  // 就诊人升级电子健康卡
  updateEHealthCard(data = {}) {
    return $axios.post(baseUrl+"/patient/ehealth/update", data);
  },
  // 获取民族下拉列表
  getNationList(data = {}) {
    return $axios.get(baseUrl+"/nation/select", {
      params: { ...data }
    });
  },
  // 检验、检查报告查询列表
  getReportQueryOne(data = {}) {
    return $axios.get(baseUrl+"/report/list", {
      params: { ...data }
    });
  },
  // 体检报告查询列表
  getReportQueryTwo(data = {}) {
    return $axios.get(baseUrl+"/medical/exam/report/list", {
      params: { ...data }
    });
  },
  // 住院日清单列表
  getNissinDetailList(data = {}) {
    return $axios.get(baseUrl+"/inpatient/bill/detail", {
      params: { ...data }
    });
  },
  // 已缴费记录列表
  getAlreadyPayCost(data = {}) {
    return $axios.get(baseUrl+"/bill/paid/list", {
      params: { ...data }
    });
  },
  // 成都医院添加就诊人
  addPatient(data = {}) {
    return $axios.post(baseUrl+"/patient/add", data);
  },
  // 解绑就诊人
  cancelBindPeople(data = {}) {
    return $axios.get(baseUrl+"/patient/del", {
      params: { ...data }
    });
  },
  // 查看报告pdf
  getReportPdf(data = {}) {
    for (let key in data) {
      if (key == "pdfUrl") {
        data[key] = decodeURIComponent(data[key]);
      }
    }
    return $axios.get(baseUrl2+"/report/view", {
      params: { ...data },
      headers: { "Content-Type": "application/pdf" },
      responseType: "arraybuffer"
    });
  },
  //体检套餐label列表
  getMedicalExamLabel(data = {}) {
    return $axios.get(baseUrl+"/medical/exam/label", {
      params: { ...data }
    });
  },
  //体检套餐list列表
  getMedicalExamList(data = {}) {
    return $axios.get(baseUrl+"/medical/exam/list", {
      params: { ...data }
    });
  },
  //科室列表
  getDeptList(data = {}) {
    return $axios.get(baseUrl+"/dept/list", {
      params: { ...data }
    });
  },
  //报名确认
  toEnroll(data = {}) {
    return $axios.post(baseUrl+"/xxxxx/xxx", data);
  },
  //签到确认
  toSignin(data = {}) {
    return $axios.post(baseUrl+"/xxxxx/xxx", data);
  },

  ...patientApi,
  ...micApi
}
export default API